import { render, staticRenderFns } from "./ReferencesCards.vue?vue&type=template&id=f1a512c6&"
import script from "./ReferencesCards.vue?vue&type=script&lang=js&"
export * from "./ReferencesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports